export const COLORS = {
  appBackground: 'papayawhip',
  cellBackgroundHidden: '#e2e2e2',
  cellBackgroundExposed: '#d5d5d5',
  hoverTint: 'rgba(0,0,0,0.1)',
  oneBlue: '#0000ff',
  twoGreen: '#008100',
  threeOrange: '#ff1300',
  fourViolet: '#000083',
  fiveRed: '#810500',
  sixTeal: '#2a9494',
  sevenYellow: '#FFFF99',
  eightMagenta: '#FF00FF',
  flagRed: '#ff0000',
  explodedMineBackground: '#ff0000',
  borders: {
    cell: { bright: 'white', medium: '#bbbbbb', dark: 'gray' },
  },
  sevenSegment: {
    background: 'black',
    color: 'red',
  },
}
